module.exports = __webpack_public_path__ + "labioplastika_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/labioplastika_3_before.jpg
// module id = 1072
// module chunks = 0